export default __webpack_public_path__ + "static/media/remove-btn.4f1baea4.svg";